<template>
  <div>
    <div :style="{ maxHeight: showTags ? '' : '200px', overflow: showTags ? 'block' : 'hidden' }">
      <template v-if="value.length > 0">
        <v-chip
          small
          v-for="(count, index) in tags"
          :key="'tag_' + index"
          outline
          color="primary"
          disabled
          >{{ index }}{{ count > 1 ? ` (${count})` : '' }}</v-chip
        >
      </template>
      <div class="primary--text" v-else>-</div>
    </div>
    <v-btn small block flat @click="showTags = !showTags">
      <v-icon>{{ showTags ? 'expand_less' : 'expand_more' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    tags() {
      return this.value
        ? this.value.reduce((prev, curr) => {
            if (Object.prototype.hasOwnProperty.call(prev, curr)) {
              prev[curr]++
            } else {
              prev[curr] = 1
            }
            return prev
          }, {})
        : {}
    }
  },
  data() {
    return {
      showTags: false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/TagGroup.vue